import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import DownIcon from "@mui/icons-material/KeyboardArrowDown";
import styledComponent from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { getListProduto } from "../../../../Services/produtoService";
import CardLoadingSvg from "../../../../Images/cardLoading.svg";
import { produtoAdd, produtoUpdate } from "../../../../Services/cardService";

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  gap: "0.25rem",
  padding: "0.25rem 0.5rem",
  color: "black",
  backgroundColor: "rgba(0, 0, 0, 0.03)",
  border: "none",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-around",

  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  "&:active": {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
});

const LoadingBox = styledComponent.div`
	height: 3rem;
	width: 8rem;
	padding: 0.5rem 3rem;
	background-image: url(${(props) => props.image});
	background-position: center;
	background-repeat: no-repeat;
`;

const Span = styledComponent.span`
font-size: 0.85rem;
display:block;
`;

const StyledIcon = styled(DownIcon)({
  display: "block",
  fontSize: "1.3rem",
});

export default function DropdownProduto() {
  const thisCard = useSelector((state) => state.card);

  const dispatch = useDispatch();
  const fictitiousProducts = [
    {
    _id: "d4c6f456a7b8e90123defa04",
    description: "1.1 - PROJETOS (DISCIPLINAS DIVERSAS)"
  },
  {
    _id: "e5d5a567b8c9fa1234efab05",
    description: "1.2 - PROJETOS (INTERFERÊNCIAS)"
  },
  {
    _id: "f6e4b678c9dafb2345fabc06",
    description: "1.3 - PROJETOS (OBRAS DE ARTE ESPECIAIS)"
  },
  {
    _id: "07f3c789dafc0c3456abcd07",
    description: "2.1 - ANÁLISE DE PROJETOS (DISCIPLINAS DIVERSAS)"
  },
  {
    _id: "18a2d890ebfd1d4567bcde08",
    description: "2.2 - ANÁLISE DE PROJETOS (OBRAS DE ARTE ESPECIAIS)"
  },
  {
    _id: "6749c466eae16144ce28db10",
    description: "3.1.1 - CONSULTORIA TÉCNICA SUPRO"
  },
  {
    _id: "6749c499eae16144ce28db11",
    description: "3.2 - CONSULTORIA ESPECIAL NORMATIVOS TÉCNICOS"
  },
  {
    _id: "6749c4a6eae16144ce28db12",
    description: "3.3 - ORÇAMENTO E ESTUDOS DE CUSTOS"
  },
  {
    _id: "6749c4b2eae16144ce28db14",
    description: "3.4 - MODELAGEM BIM"
  },
  {
    _id: "6749c4b3eae16144ce28db15",
    description: "3.5 - ASSESSORIA JURÍDICA ESPECIALIZADA"
  },
  {
    _id: "1a3c6d47bce932d5f3c2d8a1",
    description: "4.1 - LEVANTAMENTO AEROFOTOGRAMÉTRICO"
  },
  {
    _id: "f49b8725a9df426d4c7e632c",
    description: "4.2 - LEVANTAMENTO TOPOGRÁFICO - LINEAR"
  },
  {
    _id: "46c7988be5d34dc5b05cc95f",
    description: "4.3 - LEVANTAMENTO TOPOGRÁFICO - OAES - ESTUDO HIDROLÓGICO"
  },
  {
    _id: "db5a42340fb44d72812ed20b",
    description: "4.4 - SONDAGEM A PERCUSSÃO"
  },
  {
    _id: "d9324ce4c67148f0bf78c01a",
    description: "4.5 - SONDAGEM ROTATIVA EM ROCHA SÃ"
  },
  {
    _id: "1fb04e72c2644fd7b274d823",
    description: "4.6 - SONDAGEM ROTATIVA EM ROCHA ALTERADA"
  },
  {
    _id: "ba874d09f8c645d0be10c22e",
    description: "4.7 - SONDAGEM A TRADO"
  },
  {
    _id: "1d9b44b35f2c4a24936f4e2b",
    description: "4.8 - COLETA DE MATERIAL DIVERSO NA VIA FERROVIÁRIA"
  },
  {
    _id: "61e8fb74e9f24b05b5d7909d",
    description: "4.9 - TRANSPORTE DE MATERIAL DIVERSO COLETADO EM VIA FERROVIÁRIA - RODOVIA EM LEITO NATURAL"
  },
  {
    _id: "7e7ac69cdd9948789aa1c807",
    description: "4.10 - TRANSPORTE DE MATERIAL DIVERSO COLETADO EM VIA FERROVIÁRIA - RODOVIA PAVIMENTADA"
  },
  {
    _id: "db0d8e10d59a46debf88b7d3",
    description: "4.11 - LIMITE DE PLASTICIDADE"
  },
  {
    _id: "c58de13c90e64897a43a3dc7",
    description: "4.12 - LIMITE DE LIQUIDEZ"
  },
  {
    _id: "3151afc8d44f43769f1aeb91",
    description: "4.13 - ANALISE GRANULOMETRICA SEM SEDIMENTACAO (PENEIRAMENTO)"
  },
  {
    _id: "155972ff0df24e1a900bdaac",
    description: "4.14 - MASSA ESPECIFICA REAL"
  },
  {
    _id: "32b6f3e5c2924c6ba7258633",
    description: "4.15 - EQUIVALENTE DE AREIA"
  },
  {
    _id: "2f6d3f963def4ba08a242a7c",
    description: "4.16 - COMPACTACAO: ENERGIA PROCTOR NORMAL"
  },
  {
    _id: "c644153f70824f6b8ff5e2e2",
    description: "4.17 - COMPACTACAO: ENERGIA AASHO INTERMEDIARIA"
  },
  {
    _id: "4a588adad46449dcba3d5a7f",
    description: "4.18 - COMPACTACAO: ENERGIA AASHO MODIFICADA"
  },
  {
    _id: "b32008a120ae4c9d9a89e54a",
    description: "4.19 - INDICE SUPORTE CALIFORNIA, POR 1 PONTO, COMPACTACAO COM ENERGIA PROCTOR NORMAL"
  },
  {
    _id: "6e08a3c37b81441fa6e98383",
    description: "4.20 - INDICE SUPORTE CALIFORNIA, POR 1 PONTO, COMPACTACAO COM ENERGIA AASHO INTERMEDIARIA"
  },
  {
    _id: "71ebf4cfdd32482abef1b6f2",
    description: "4.21 - INDICE SUPORTE CALIFORNIA, POR 1 PONTO, COMPACTACAO COM ENERGIA AASHO MODIFICADA"
  },
  {
    _id: "92dc24ba6e5c426e91cf8019",
    description: "4.22 - TRIAXIAL DRENADO, EM AMOSTRAS NATURAL OU MOLDADA, POR CORPO DE PROVA"
  },
  {
    _id: "882340cfb3904380b231dd94",
    description: "4.23 - ANALISE GRANULOMETRICA EM AGREGADO MIUDO"
  },
  {
    _id: "4f6df34b5df84e2c9817fcbe",
    description: "4.24 - ANALISE GRANULOMETRICA EM AGREGADO GRAUDO"
  },
  {
    _id: "a68f7870ed014acfa5b94f8b",
    description: "4.25 - DESGASTE A ABRASAO \"LOS ANGELES\""
  },
  {
    _id: "15c3e4c5cb8e4d31b160e68b",
    description: "4.26 - DETERMINACAO DE PERCENTAGEM DE CARBONATO DE CALCIO"
  },
  {
    _id: "75e64e2b07cd46ecb47a869e",
    description: "4.27 - ABERTURA DE PICADAS EM TERRENO COM VEGETACAO QUE POSSIBILITE O USO APENAS DE FACAO E FOICE"
  },
  {
    _id: "8f1b4c983fa040caa7754906",
    description: "4.28 - ABERTURA DE PICADAS EM TERRENO QUE EXIJA ALEM DO USO DE FACAO E FOICE,TAMBEM MACHADO E MOTOSSERRA"
  },
  {
    _id: "e8fb00ed0cbf427093d2442e",
    description: "4.29 - EXECUCAO DE LINHA DE PROSPECCAO GEOFISICA PELO METODO DE CAMINHAMENTO ELETRICO"
  },
  {
    _id: "8ce5e92fa5314bc6b126f23b",
    description: "4.30 - ABERTURA DE POÇO DE INSPEÇÃO PARA COLETA DE AMOSTRA NÃO DEFORMADA"
  },
  {
    _id: "162ba70bd9704adbad75c15e",
    description: "4.31 - ENSAIO DE PALHETA(\"VANE TEST\")REALIZADO NO CAMPO,EXCLUSIVE PERFURACAO"
  },
  {
    _id: "4358dd6c9ad4471b9243e2ef",
    description: "4.32 - DETERMINACAO DA PERDA DE MASSA POR IMERSAO DE SOLOS COMPACTADOS EM EQUIPAMENTO MINIATURA"
  },
  {
    _id: "bdde54e073aa470b9fddebd2",
    description: "4.33 - EXTRACAO DE AMOSTRA INDEFORMADA EM BLOCOS DE 30X30X30CM"
  },
  {
    _id: "4a40457f66db4c51a2db937d",
    description: "4.34 - UMIDADE NATURAL EM ESTUFA"
  },
  {
    _id: "e23e6b21d2954df9bf5796d4",
    description: "4.35 - CISALHAMENTO LENTO OU RAPIDO,POR CORPO DE PROVA"
  },
  {
    _id: "4a40458066db4c51a2db937e",
    description: "4.36 - TRIAXIAL NAO DRENADO, PRE-ADENSADO, EM AMOSTRAS NATURAL OU MOLDADA, POR CORPO DE PROVA"
  },
  {
    _id: "4a40458166db4c51a2db937f",
    description: "4.37 - MINI-MCV - SOLO COMPACTADO EM EQUIPAMENTO MINIATURA"
  },
  {
    _id: "4a40458266db4c51a2db9380",
    description: "4.38 - DETERMINACAO DE MASSA ESPECIFICA APARENTE \"IN SITU\" COM EMPREGO DO FRASCO DE AREIA."
  },
  {
    _id: "4a40458366db4c51a2db9381",
    description: "4.39 - POROSIDADE APARENTE (ABNT NBR 7418)."
  },
  {
    _id: "4a40458466db4c51a2db9382",
    description: "4.40 - ABSORÇÃO DE ÁGUA (ABNT NBR 7418)."
  },
  {
    _id: "4a40458566db4c51a2db9383",
    description: "4.41 - RESISTÊNCIA MÍNIMA À COMPRESSÃO SIMPLES AXIAL."
  },
  {
    _id: "4a40458666db4c51a2db9384",
    description: "4.42 - RESISTENCIA AO IMPACTO \"TRETON\"."
  },
  {
    _id: "4a40458766db4c51a2db9385",
    description: "4.43 - MASSA UNITÁRIA (MASSA UNITÁRIA E VAZIOS)."
  },
  {
    _id: "4a40458866db4c51a2db9386",
    description: "4.44 - AVALIACAO DAS IMPUREZAS ORGANICAS DAS AREIAS."
  },
  {
    _id: "4a40458966db4c51a2db9387",
    description: "4.45 - QUALIDADE DA AREIA COM ANALISE GRANULOMETRICA E INDICE DE MATERIA ORGANICA."
  },
  {
    _id: "4a40458a66db4c51a2db9388",
    description: "4.46 - TEOR DE ARGILA EM TORROES (AGREGADO MIUDO)."
  },
  {
    _id: "4a40458b66db4c51a2db9389",
    description: "4.47 - TEOR DE ARGILA EM TORROES (AGREGADO GRAUDO)."
  },
  {
    _id: "4a40458c66db4c51a2db938a",
    description: "4.48 - TEOR DE MATERIAIS PULVERULENTOS (AGREGADO MIUDO)."
  },
  {
    _id: "4a40458d66db4c51a2db938b",
    description: "4.49 - TEOR DE MATERIAIS PULVERULENTOS (AGREGADO GRAUDO)."
  },
  {
    _id: "4a40458e66db4c51a2db938c",
    description: "4.50 - INDICE DE FORMA (CUBICIDADE)."
  },
  {
    _id: "4a40458f66db4c51a2db938d",
    description: "4.51 - DENSIDADE APARENTE (AGREGADO MIUDO)."
  },
  {
    _id: "4a40459066db4c51a2db938e",
    description: "4.52 - DENSIDADE APARENTE (AGREGADO GRAUDO)."
  },
  {
    _id: "4a40459166db4c51a2db938f",
    description: "4.53 - MASSA ESPECÍFICA APARENTE, ABSORÇÃO E POROSIDADE."
  },
  {
    _id: "4a40459266db4c51a2db9390",
    description: "4.54 - GRANULOMETRIA COM SEDIMENTAÇÃO."
  },
  {
    _id: "7c55f45809b442fd865c4b63",
    description: "5.1 - PASSAGENS AÉREAS"
  },
  {
    _id: "650630a522504f10932cb6e0",
    description: "5.2 - DIÁRIAS"
  },
  {
    _id: "df3d9dc2bce242ef96b202a3",
    description: "5.3 - DIÁRIA DE VEÍCULO TIPO PICK-UP"
  },
  {
    _id: "0718501bce5a46b7b4ebf85c",
    description: "5.4 - DIÁRIA DE VEÍCULO TIPO LEVE"
  }
];

  const [produtoData, setProdutoData] = useState(fictitiousProducts);
  const [produto, setProduto] = useState(thisCard.produto);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedProduto, setSelectedProduto] = useState(null);

  const open = Boolean(anchorEl);
  const handleClick = async (event) => {
    setAnchorEl(event.currentTarget);
    setLoading(true);
    try {
      //      await getListProduto(true);
    } catch (error) {
      console.error("Falha ao buscar quadros:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (produto) {
      const selected = produtoData.find((p) => p._id === produto);
      if (selected) {
        setSelectedProduto(selected);
      }
    }
  }, [produto, produtoData]);

  const handleSelect = async (item) => {
    setSelectedProduto(item);
    setAnchorEl(null);

    if (produto) {
      await produtoAdd(
        thisCard.cardId,
        thisCard.listId,
        thisCard.boardId,
        item._id,
        dispatch
      );
    } else {
      await produtoAdd(
        thisCard.cardId,
        thisCard.listId,
        thisCard.boardId,
        item._id,
        dispatch
      );
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <BootstrapButton
        id="demo-positioned-button"
        aria-controls="demo-positioned-menu"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        type="button"
      >
        <Span>{selectedProduto?.description ?? "Selecione"}</Span>
        <Span>
          <StyledIcon />
        </Span>
      </BootstrapButton>
      {Object.keys(produtoData).length > 0 && (
        <Menu
          id="demo-positioned-menu"
          aria-labelledby="demo-positioned-button"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          {!loading ? (
            produtoData.map((item) => {
              return (
                <MenuItem key={item._id} onClick={() => handleSelect(item)}>
                  <Span>{item.description}</Span>
                </MenuItem>
              );
            })
          ) : (
            <LoadingBox image={CardLoadingSvg} />
          )}
        </Menu>
      )}
    </div>
  );
}
